import { useState, useEffect } from "react"
import { useGraphQLDatas } from "../../components/UserContext"
import _ from 'lodash'
import { useHistory } from 'react-router-dom'
import useUpdateEffect from '../../../../utils/useUpdateEffect'

// graphql
import gql from 'graphql-tag'
import { useMutation, useLazyQuery } from '@apollo/react-hooks'

//styles
import './UpsertUser.css'

// semantic ui react
import {
  Container,
  Segment,
  Header,
  Form,
  Button,
  Message,
  Loader
} from 'semantic-ui-react'

const GET_USER = gql`
  query GetUser($id: ID!) {
    me {
      id
      user (id: $id) {
        id
        name
        email
        username
        admin
        meta
      }
    }
  }
`
const CREATE_USER = gql`
  mutation CreateUserMutation($input: CreateUserInput!) {
    create_user(input: $input) {
      id
      name
    }
  }
`
const UPDATE_USER = gql`
  mutation UpdateUserMutation($input: UpdateUserInput!) {
    update_user(input: $input) {
      id
      name
    }
  }
`

const UpsertUser = props => {
  // states
  const [me, setMe] = useState()
  const [user, setUser] = useState()
  const [mode, setMode] = useState()
  const [backendErrorMessage, setBackendErrMessage] = useState(false)
  const [duplicateErrorMessage, setDuplicateErrorMessage] = useState(false)
  const [successMessage, setSuccessMessage] = useState(false)
  const [passwordRelVal, setPasswordRelVal] = useState(null)
  const [updatePassInfo, setUpdatePassInfo] = useState(false)
  const [error, setError] = useState()

  // get me
  let { loading, data } = useGraphQLDatas()
  useEffect(() => {
    if (!loading && data) {
      let { id, email, username, name, admin } = data.me
      setMe({ id, email, username, name, admin })
    }
  }, [data])

  useEffect(() => {
    if (mode && mode === 'create') {
      // hide first time edit message
      setUpdatePassInfo(false)
    }
  }, [mode])

  let history = useHistory()
  // set user after geting me
  useEffect(() => {
    if (me && me.id) {
      // default user for '/create'
      let defaultUser = {
        id: '',
        email: '',
        username: '',
        name: '',
        password: '',
        changePassword: true,
        ssh: '',
        updatedPassword: false,
        admin: false
      }
      if (props && props.match.params && props.match.params.id) {
        let propsId = props.match.params.id
        if (propsId === 'create') {
          // redirected from iregular route
          if (me.admin) {
            setMode('create')
            setUser(defaultUser)
          } else redirectMe()
        } else {
          // editing existing user
          setMode('edit')
          // strip '/users/' if redirected
          let id = propsId.split('/')
          id = id[id.length - 1]
          getUser({variables: { id }})
        }
      } else {
        // regular '/create' route
        if (me.admin) {
          setMode('create')
          setUser(defaultUser)
        } else redirectMe()
      }
    }
  }, [me, props])

  const redirectMe = () => {
    let urlParams = (props && props.match && props.match.params && props.match.params.id) || null
    if (me && me.admin) {
      setMode('create')
      // prevent overquerying
      if (urlParams && urlParams !== 'create') history.push('/users/create')
    } else {
      setMode('edit')
      // prevent overquerying
      if (!urlParams || urlParams !== me.id) history.push(`/users/${me.id}`)
    }
  }

  // get user (query)
  const [getUser, { error: userError, refetch, loading: loadingUser, called: calledUser }] = useLazyQuery(GET_USER, {
    fetchPolicy: 'network-only',
    onCompleted: userData => {
      if (userData) {
        // found user
        let { id, email, username, name, meta, admin } = userData.me.user
        let ssh = (meta && meta.public_key) || ''
        let updatedPassword = (meta && meta.updated_password) || false
        if (me.id === id) {
          updatedPassword = (meta && meta.updated_password) || false
        } else {
          // act as already updated for not me
          updatedPassword = true
        }
        setUpdatePassInfo(!updatedPassword)
        let changePassword = !updatedPassword
        setUser({ id, email, username, name, password: '', changePassword, ssh, updatedPassword, admin })
      } else {
        // no data - redirect
        redirectMe()
      }
    },
    onError: err => {
      console.log(err)
      // not found user under that ID or invalid uuid - redirect
      redirectMe()
    }
  })

  // show success message handler
  const showSuccessMessage = () => {
    setSuccessMessage(true)
    setTimeout(() => {
      setSuccessMessage(false)
    }, 3000)
  }
  // show backend error handler
  const showBackendErrorMessage = () => {
    setBackendErrMessage(true)
    setTimeout(() => {
      setBackendErrMessage(false)
    }, 6000)
  }
  // show duplicate error handler
  const showDuplicateErrorMessage = () => {
    setDuplicateErrorMessage(true)
    setTimeout(() => {
      setDuplicateErrorMessage(false)
    }, 8000)
  }

  // graphql mutations
  const [createUser] = useMutation(CREATE_USER, {
    fetchPolicy: 'network-only',
    onCompleted: createMutationData => {
      let createdUser = createMutationData.create_user
      // backend error
      if (!createdUser) {
        showBackendErrorMessage()
      } else {
        // set success message
        showSuccessMessage()
        // clear all fields
        setUser({
          id: '',
          email: '',
          username: '',
          name: '',
          password: '',
          changePassword: true,
          ssh: '',
          updatedPassword: false,
          admin: false
        })
        // hide error messages
        setBackendErrMessage(false)
        setDuplicateErrorMessage(false)
      }
    },
    onError: createdMutationError => {
      setError(createdMutationError)
      if (createdMutationError &&
        createdMutationError.message &&
        createdMutationError.message === 'Duplicate'
      ) {
        showDuplicateErrorMessage()
      } else {
        showBackendErrorMessage()
        console.log(createdMutationError)
      }
    }
  })
  const [updateUser] = useMutation(UPDATE_USER, {
    fetchPolicy: 'network-only',
    onCompleted: updatedMutationData => {
      let updatedUser = updatedMutationData.update_user
      // backend error
      if (!updatedUser) {
        showBackendErrorMessage()
      } else {
        // set success message
        showSuccessMessage()
        // hide error messages
        setBackendErrMessage(false)
        setDuplicateErrorMessage(false)
      }
    },
    onError: updatedMutationError => {
      setError(updatedMutationError)
      if (updatedMutationError &&
        updatedMutationError.message &&
        updatedMutationError.message === 'Duplicate'
      ) {
        showDuplicateErrorMessage()
      } else {
        showBackendErrorMessage()
        console.log(updatedMutationError)
      }
    }
  })

  const handleSubmit = e => {
    let { id, email, username, name, admin } = user
    // public_key
    let params = {
      id,
      email,
      username,
      name,
      admin
    }
    if (user && user.ssh && user.ssh !== '') params.meta = { public_key: user.ssh}
    if (user && user.changePassword && user.password && user.password !== '') {
      // set password
      params.password = user.password
      // set updated_password
      if (me.id === user.id) {
        // set params for mutation
        params.meta = { ...params.meta, updated_password: true}
        // change states
        setUpdatePassInfo(false)
        setUser({ ...user, changePassword: false, updatedPassword: true })
      } else {
        params.meta = { ...params.meta, updated_password: false }
        setUpdatePassInfo(false)
        setUser({ ...user, changePassword: false })
      }
    }
    // graphql mutations
    if (mode && mode === 'edit') {
      updateUser({
        variables: {
          input: { ...params }
        }
      })
    } else if (mode && mode === 'create') {
      // kick put id
      params = _.omit(params, 'id')
      // add password
      params.password = user.password
      createUser({
        variables: {
          input: { ...params }
        }
      })
    }
  }
  const handleChange = (value, field) => {
    let newUser = _.cloneDeep(user)
    newUser[field] = value
    setUser(newUser)
  }

  // hooks password timeout
  let passwordTimeout
  useEffect(() => {
    if (passwordRelVal && user && user.password) {
      // reveal hiden letters for 0.5s
      clearTimeout(passwordTimeout)
      passwordRelVal.type = 'text'
      passwordTimeout = setTimeout(() => {
        passwordRelVal.type = 'password'
      }, 500)
    }
    return () => clearTimeout(passwordTimeout)
  }, [user && user.password])


  return (
    <Container className='UpsertUser'>
      {calledUser && loadingUser && (<Loader active>Loading...</Loader>)}
      {((!loadingUser && calledUser) || mode === 'create') && (
        <>
          <Header as='h3' attached='top'>
            {mode && mode === 'edit' ? 'Edit Profile:' : 'Create Profile:'} <span>{user && user.username}</span>
          </Header>
          <Segment attached='bottom'>
            {/* messages */}
            {backendErrorMessage && (
              <Message
                negative
                size='small'
                onDismiss={() => setBackendErrMessage(false)}
              >
                <Message.Header>Failed to {mode} profile!</Message.Header>
                <p>Backend refused to {mode && mode === 'edit' ? 'make changes on' : 'create'} this profile!</p>
              </Message>
            )}
            {duplicateErrorMessage && (
              <Message
                negative
                size='small'
                onDismiss={() => setDuplicateErrorMessage(false)}
              >
                <Message.Header>Database Duplicate Error!</Message.Header>
                <p>
                  {error && error.graphQLErrors && error.graphQLErrors.map((err, i) => (
                    <span key={i}>
                      User with: <br />
                      <b>{err.extensions.exception.column}</b> : <b>{err.extensions.exception.value}</b> <br/>
                      Already exists in Database
                    </span>
                  ))}
                </p>
              </Message>
            )}
            {successMessage && (
              <Message
                positive
                size='small'
              >
                <Message.Header>Success!</Message.Header>
                <p>Successfully edited profile!</p>
              </Message>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Field>
                <Form.Input
                  type='text'
                  required
                  label='Name'
                  name='name'
                  placeholder='Name'
                  value={(user && user.name) || ''}
                  onChange={(e, { value }) => handleChange(value, 'name')}
                />
              </Form.Field>
              <Form.Field>
                <Form.Input
                  type='text'
                  required
                  label='Username'
                  name='username'
                  placeholder='Username'
                  value={(user && user.username) || ''}
                  onChange={(e, { value }) => handleChange(value, 'username')}
                />
              </Form.Field>
              <Form.Field>
                <Form.Input
                  type='email'
                  required
                  label='E-mail'
                  name='email'
                  placeholder='E-mail'
                  value={(user && user.email) || ''}
                  onChange={(e, { value }) => handleChange(value, 'email')}
                />
              </Form.Field>
              <Form.Group inline>
                <Form.Field width={10}>
                  <Form.Input
                    width={16}
                    type='password'
                    required={((user && user.changePassword) || (user && !user.updatedPassword))}
                    label='New Password'
                    name='password'
                    disabled={!((user && user.changePassword) || (user && !user.updatedPassword))}
                    onKeyDown={({ target }) => setPasswordRelVal(target)}
                    placeholder='Password'
                    value={(user && user.password) || ''}
                    onChange={(e, { value }) => handleChange(value, 'password')}
                  />
                </Form.Field>
                {mode && mode === 'edit' && (
                  <Form.Field width={6}>
                    <Form.Checkbox
                      label='Change Password'
                      toggle
                      checked={((user && user.changePassword) || (user && !user.updatedPassword))}
                      onChange={() => setUser({ ...user, changePassword: !user.changePassword })}
                    />
                  </Form.Field>
                )}
              </Form.Group>
              {updatePassInfo && user && user.changePassword && (
                <Message
                  info
                  size='small'
                  className='info-message'
                >
                  <Message.Header>Update your password!</Message.Header>
                  <p>It is highly recomendable to change default password into something you could remmember!</p>
                </Message>
              )}
              <Form.Field>
                <Form.TextArea
                  style={{ minHeight: 150 }}
                  label='Public SSH key'
                  name='ssh'
                  placeholder='copy/paste your SSH here...'
                  value={(user && user.ssh) || ''}
                  onChange={(e, { value }) => handleChange(value, 'ssh')}
                />
              </Form.Field>
              {me && user && me.admin && user.id !== me.id && (
                <Form.Field width={6}>
                  <Form.Checkbox
                    label={`Administrator Privileges: ${(user && user.admin) ? 'YES' : 'NO'}`}
                    toggle
                    checked={(user && user.admin)}
                    onChange={() => setUser({ ...user, admin: !user.admin })}
                  />
                </Form.Field>
              )}
              <br /><br />
              <Form.Field>
                <Button type='submit' primary>Submit</Button>
              </Form.Field>
            </Form>
          </Segment>
        </>
      )}
    </Container>
  )
}

export default UpsertUser
